import { MY_GROUPS_PATH } from '../shared/constants';
import { settingsManager } from '../shared/settings';
import {
  DEFAULT_OCV_APP_ID,
  IPFBrowserStorageOverrideKey,
  IFeedbackItem,
  IPFAppName,
  IPFFeatureArea,
  KnownIPFSurveyName,
} from './constants';

export function isUserInitiatedIPFEnabledInSetting(tenantId: string | undefined) {
  try {
    const IPFSetting = settingsManager.getRequired('inProductFeedback');
    return (
      IPFSetting.isInProductFeedbackEnabled &&
      IPFSetting.userInitiated.header.enabled &&
      !!tenantId &&
      !IPFSetting.userInitiated.header.excludedTenants.includes(tenantId)
    );
  } catch (e) {
    return false;
  }
}

export function isSystemInitiatedIPFEnabledInSetting(tenantId: string) {
  try {
    const IPFSetting = settingsManager.getRequired('inProductFeedback');
    return (
      IPFSetting.isInProductFeedbackEnabled &&
      IPFSetting.systemInitiated.enabled &&
      !IPFSetting.systemInitiated.excludedTenants.includes(tenantId)
    );
  } catch (e) {
    return false;
  }
}

export function isTaskInitiatedIPFEnabledInSetting(feedbackId: string, tenantId: string) {
  try {
    const IPFSetting = settingsManager.getRequired('inProductFeedback');
    return (
      IPFSetting.isInProductFeedbackEnabled &&
      IPFSetting.taskInitiated.locations[feedbackId].enabled &&
      !IPFSetting.taskInitiated.locations[feedbackId].excludedTenants.includes(tenantId)
    );
  } catch (e) {
    return false;
  }
}

export function getIPFOverrideSetting(ipfType: keyof typeof IPFBrowserStorageOverrideKey) {
  const result = {
    isOverriden: false,
    shouldShow: false,
  };
  try {
    const shouldShowState = localStorage.getItem(IPFBrowserStorageOverrideKey[ipfType].key);
    if (shouldShowState !== null) {
      result.isOverriden = true;
      result.shouldShow = JSON.parse(shouldShowState);
    }
  } catch {
    // do nothing
  }
  return result;
}

export function getIPFFeatureAreaType() {
  return isUnderGroupsSubPages() ? IPFFeatureArea.MyGroup : IPFFeatureArea.MyAccount;
}

export function getIPFAppName() {
  return isUnderGroupsSubPages() ? IPFAppName.MyGroup : IPFAppName.MyAccount;
}

export function getSystemInitiatedIPFSurveyNameBasedOnCurrentPage() {
  return isUnderGroupsSubPages()
    ? KnownIPFSurveyName.mygroupssysteminitiated
    : KnownIPFSurveyName.myaccountsysteminitiated;
}
export function getUserInitiatedFeedbackitem(feedbackItems: Record<string, IFeedbackItem>) {
  return isUnderGroupsSubPages()
    ? feedbackItems[KnownIPFSurveyName.mygroupsgenericuserinitiated]
    : feedbackItems[KnownIPFSurveyName.myaccountgenericuserinitiated];
}

export function getBasedFeedbackMetadata() {
  try {
    const IPFSetting = settingsManager.getRequired('inProductFeedback');
    return {
      ocvClientFeedbackLink: IPFSetting.ocvClientFeedbackLink ?? '',
      appId: IPFSetting.ocvAppId ?? DEFAULT_OCV_APP_ID,
      tenantId: '',
      featureArea: getIPFFeatureAreaType(),
      surveyId: '2a14fff8-25ea-4888-af31-ffe9973743d1', // generic survey id
      surveyName: '',
      ocpsEndpoint: IPFSetting.ocpsEndpoint ?? '',
    };
  } catch (e) {
    return null;
  }
}

function isUnderGroupsSubPages() {
  return window.location.pathname.includes(MY_GROUPS_PATH);
}
